module.exports = __webpack_public_path__ + "img/sfjd_03.b3291d90.jpg";